export const foundationSpacingTokens = {
  button: {
    sm: 'h-8 px-3',
    md: 'h-9 px-4',
    lg: 'h-10 px-5'
  },
  input: {
    field: 'px-3 py-1',
    textarea: 'px-3 py-2'
  },
  menuItem: 'px-4 py-2',
  dialog: {
    header: 'px-4 py-3',
    body: 'p-4',
    footer: 'px-4 py-3'
  },
  navItem: 'h-10 px-3',
  avatar: {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-24 w-24'
  }
} as const;